import {
  ANALYTICS_INPUT_COPY,
  INPUT_BINDING_COPY,
} from "../../../lib/analyticsFeeds";
import { documentsGridColumns } from "./documentsGrid";

/**
 * The Documents tab's column headings.
 *
 * Its own component because it is `DocumentRow`'s twin: the two read the same
 * track list and hand-write their cells in the same order, so a column moved in
 * one and not the other puts every heading over the wrong control. Separated,
 * the pair can be rendered side by side and their order compared.
 */
interface DocumentsHeaderRowProps {
  procedureBasis: "sample" | "direct";
  hasAnalytics: boolean;
}

export function DocumentsHeaderRow({
  procedureBasis,
  hasAnalytics,
}: DocumentsHeaderRowProps) {
  return (
    <div
      className={`grid ${documentsGridColumns(hasAnalytics, procedureBasis)} bg-white border-b sticky top-0 z-10 text-font-secondary text-sm w-full`}
    >
      <div className="p-2"></div>
      <div className="p-2 font-normal flex items-center gap-2">Title</div>
      {procedureBasis === "sample" && (
        <div className="p-2 font-normal">Sample Match</div>
      )}
      {hasAnalytics && (
        <>
          {/* The helper sits on the heading rather than in every row: it
              describes the column, and one sentence per document is the
              same sentence N times. */}
          <div
            className="p-2 font-normal"
            title={ANALYTICS_INPUT_COPY.flagHelper}
          >
            {ANALYTICS_INPUT_COPY.flagColumnHeading}
          </div>
          <div className="p-2 font-normal">
            {INPUT_BINDING_COPY.parametersColumnHeading}
          </div>
        </>
      )}
      <div className="p-2 font-normal">Document Category</div>
      <div className="p-4 w-12"></div>
    </div>
  );
}
